import $ from 'jquery';

export default class JobHighlight {
	init() {
		this.adjustBackgroundHeight();
	}

	adjustBackgroundHeight() {
		$('.atl-job-highlight').each((index, element) => {
			const $element = $(element);
			const contentHeight =
				$(window).width() < 992
					? $element.find('.description').height() + 20
					: $element.find('.description').height();
			$element.find('.colored-bg-element').height(`${contentHeight}px`);
		});
	}
}
